import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
//components
import Input from "../../../input/Input";
import Select from "../../../input/Select";
import MaskInput from "../../../input/MaskInput";
///utils
import { states } from "../../../../utils/states";
import { handleCep } from "../../../../utils/handleCep";
//services

export const Address = forwardRef(({ onSubmitAddress, address }, ref) => {
  const {
    control,
    setValue,
    getValues,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [localAddress, setLocalAddress] = useState({});
  const [inputRequireds, setInputRequireds] = useState([]);

  const handleInputRequireds = () => {
    var auxRegisterGeneral = localStorage.getItem("registerGeneral");
    setInputRequireds(auxRegisterGeneral);
  };

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitAddress)(),
    getValues: () => getValues(),
  }));

  useEffect(() => {
    if (localAddress && Object.keys(localAddress).length !== 0) {
      setValue("address", localAddress.address);
      setValue("city", localAddress.city);
      setValue("neighborhood", localAddress.neighborhood);
      setValue("state", localAddress.state);
      clearErrors(["address", "city", "neighborhood", "state"]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localAddress]);

  useEffect(() => {
    if (address) {
      Object.keys(address).forEach((key) => {
        setValue(key, address[key]);
      });
    }
  }, [address]);

  useEffect(() => {
    handleInputRequireds();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmitAddress)}>
        <div className="row">
          <div className="col-md-3">
            <MaskInput
              name="cep"
              mask="99999-999"
              onComplete={() => handleCep(getValues("cep"), setLocalAddress)}
              control={control}
              errors={errors}
              isRequired={inputRequireds?.includes("cep")}
              label={`CEP`}
            />
          </div>
          <div className="col-md-3">
            <Input
              name="num"
              control={control}
              errors={errors}
              label={`Número`}
              isRequired={inputRequireds?.includes("num")}
            />
          </div>
          <div className="col-md-6">
            <Input
              name="complement"
              control={control}
              errors={errors}
              max={100}
              maxLength={100}
              isRequired={inputRequireds?.includes("complement")}
              label={`Complemento`}
            />
          </div>
          <div className="col-md-3 mt-2">
            <Input
              name="city"
              control={control}
              errors={errors}
              label={`Cidade`}
              isRequired={inputRequireds?.includes("city")}
            />
          </div>

          <div className="col-md-3 mt-2">
            <Select
              name="state"
              label={`Estado`}
              errors={errors}
              control={control}
              options={states}
              isRequired={inputRequireds?.includes("state")}
            />
          </div>
          <div className="col-md-3 mt-2">
            <Input
              name="address"
              control={control}
              errors={errors}
              label={`Rua`}
              isRequired={inputRequireds?.includes("address")}
            />
          </div>
          <div className="col-md-3 mt-2">
            <Input
              name="neighborhood"
              control={control}
              errors={errors}
              label={`Bairro`}
              isRequired={inputRequireds?.includes("neighborhood")}
            />
          </div>
        </div>
      </form>
    </>
  );
});
